/*
Author: Vaishnavi
Date: 27/11/2019
Issue Description: Spacing fixes done as per design guidelines
*/
<template>
<div class="main-container">
      <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />
  <div class="margintop-32">
    <toast-message :message="errmsg" type="error" :isToastEnable='toast' @close ="(val) => toast = val"/>
    <div class="row-container marginb">
      <div class="row-container align-center pull-right">
        <img src="@/assets/group-5.svg" class="Group-5" />
        <button class="text-green" @click="$router.push(`/dashboard/${this.$route.params.entity_index}/organisation/utilities/addsalarycomponent`)">Add New Component</button>
      </div>


      <!-- dropdown section starts here -->
      <div class="action-section hidden" >
        <img src="@/assets/group-2.png" @click="dropdown()" alt="actionIcon">
        <ul  class="action-menu" v-show="showDropdown">
              <li><span class="" >Display Order </span></li>
              <li> <span class="" > Pay Allocation</span></li>
              <li><span class=""> Salary Component Report Download</span></li>
          </ul>
      </div>
      <!-- dropdown section ends here -->

    </div>
    <data-table
        :columns="columnNames"
        :tableData="componentsData"
        :checkbox="true"
        :withForm="false"
        :showinheader="showinheader"
        :search="search"
        :icons="[
                 {url:require('@/assets/garbage.png'), method: 'up'},
                 {url:require('@/assets/garbage.png'), method: 'down'},
                 {url:require('@/assets/garbage.png'), method: 'deletee'}
                 ]"
        @delete="deleteItem"
        @editStart="editItem"

        @up="moveRowToUp"
        @down="moveRowToDown"
        @selected="selected"
        @deselected="deselected"
        :showhistory="false"

        
        > 
        <template v-slot:rowcontent="slotprops">
            <p v-if="slotprops.value.column.key == 'SalaryComponentType' && slotprops.value.record[slotprops.value.column.key]">
                  {{ slotprops.value.record[slotprops.value.column.key]['name']}}</p>
          <!-- </template>

          <template v-slot:rowcontent="slotprops"> -->
            <p v-if="slotprops.value.column.key == 'ITSection' && slotprops.value.record[slotprops.value.column.key]">
            {{ slotprops.value.record[slotprops.value.column.key]['name']}}</p>
            <p v-if="slotprops.value.column.key != 'ITSection' && slotprops.value.column.key != 'SalaryComponentType'" >{{slotprops.value.record[slotprops.value.column.key]}}</p>
        </template>
        </data-table>
  </div>

  <pop-up-message v-if="showConfirmDelete" :message="'Are you sure you want to delete ?'" :popupType="popupType" :popupHeaderMessage="'Confirm Delete'"
      >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancelEvent()">Cancel</button>
          <button class="btn-popup" type="button" @click="confirmDelete()">Delete</button>
        </div>
      </template>
  </pop-up-message>

  <bottom-action-container>
    <btn-skip @navClicked="$emit('stepNum', 3)"></btn-skip>
    <template slot="end">
      <btn-grp>
        <btn text="Previous" type="secondary" @click="$emit('stepNum', 1)"/>
        <btn text="Next" type="primary" @click="$emit('stepNum', 3)" />
      </btn-grp>
    </template>
  </bottom-action-container>
</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "SalaryComponents",
  computed: {
    ...mapState({
      componentTypes: state =>
        state.onboard.settings.salary_component_types.data,
      salaryComponentsData: state =>
        state.onboard.settings.salary_component.entityWiseData
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
      
    },
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    componentsData() {
       // let le_id = "f2bd8f30-b270-40b9-942e-7ae917d73781";
      // for (let i = 0; i < this.salaryComponentsData[this.leId].length; i++) {
      //   this.salaryComponentsData[this.leId][i].type = this.componentTypes
      // }
      // //console.log('dddd'+this.salaryComponentsData[this.leId]);
      return this.salaryComponentsData[this.leId];
    }
  },
  data() {
    return {
       breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
              },
              {
                name: "Salary Component",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/salarycomponent`
              }
        ],
      errmsg: "",
      toast: false,
      showDropdown: false,
      showinheader: false,
      columnNames: [
        {
          label: "Component",
          key: "name"
        },
        {
          label: "Type",
          key: "SalaryComponentType"
        },
        {
          label: "Tax Exempt",
          key: "ITSection"
        },
        {
          label: "Calculation",
          key: "formula"
        }
      ],
      search: "",
      showConfirmDelete : false,
      popupType: "ConfirmDelete",
      currentObj: {}
    };
  },
  mounted() {
    this.fetchComponentTypes();
    this.fetchAllComponents();
  },
  methods: {
    ...mapActions({
      act_fetch_component_types:
        "onboard/settings/salary_component_types/fetchAll",
      act_fetchAll: "onboard/settings/salary_component/fetchAll",
      act_delete: "onboard/settings/salary_component/delete"
    }),
    dropdown() {
      this.showDropdown = !this.showDropdown;
    },
    navHandler(navType) {
      if (navType == "back") {
        this.$emit("stepNum", 1);
        this.$validator.reset();
      } else if (navType == "next") {
        this.$emit("stepNum", 3);
        this.$validator.reset();
      }
    },
    async fetchComponentTypes() {
      try {
        await this.act_fetch_component_types();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async fetchAllComponents() {
      try {
        let res = await this.act_fetchAll(this.leId);
        if (res.message != null) {
          throw Error(res.message);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    initEditStart(rec) {
      //console.log(rec);
    },

      deleteItem(item) {
        this.showConfirmDelete = true;
        this.currentObj = item;
      },

      cancelEvent() {
        this.showConfirmDelete = false;
      },

      confirmDelete() {
        this.deleteEvent();
      },

      async deleteEvent() {
        try {
          let res = await this.act_delete(this.currentObj);
          ////console.log("res", res);
          this.showConfirmDelete = false;
          if (res.status == 200) {
             this.fetchAllComponents();
          }
        } catch (err) {
            //console.log("deleteEvent error:", err);
            //this.showConfirmDelete = false;
            //this.toast = true;
            //this.errmsg = err;
        }
      },


    async editItem(rec) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/editsalarycomponent`,
        query: { id: rec.id  }
      });
    },
    filterData(searchText) {
      this.search = searchText;
    },
    selected(records) {
      //console.log(records);
      this.showinheader = true;
      // this.editcol='lop'
    },
    deselected(records) {
      //console.log("deselected records", records);
      if (records.length == 0) {
        this.showinheader = false;
        this.editcol = "";
      }
    },
    moveRowToUp(records) {
      //console.log(records);
    },
    moveRowToDown(records) {
      //console.log("records", records);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
.row-container {
  align-items: center;
}
.Group-5 {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.export-button {
  height: fit-content;
}
.vertical-line {
  border-left: 1px solid #ececec;
  height: 25px;
  margin-left: 30px;
  margin-right: 16px;
}
.text-green {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}
.search-bar {
  width: 321px;
  border: 1px solid #d6d4d4;
  border-radius: 3px;
  height: 30px;
  padding: 5px;
  outline: none;
  position: relative;
}
.marginb {
  margin-bottom: 18px;
}
.search-icon {
  position: absolute;
  left: 295px;
  top: 6px;
  width: 18px;
  height: 18px;
}
.search-container {
  position: relative;
  margin-top: 20px;
}
.align-center {
  align-items: center;
}
</style>
